import { RISK_CENTER_TABS } from "../components/ui/shell/module-nav";

export const DEFAULT_RISK_CENTER_TAB = "dashboards";

const EXTRA_TABS = ["workflow-editor"];

export function isValidRiskCenterTab(tab) {
  if (!tab) return false;
  return RISK_CENTER_TABS.some((t) => t.id === tab) || EXTRA_TABS.includes(tab);
}

/**
 * Build a shareable Risk Center URL.
 * @param {string} tab
 * @param {{ department?: number|string, compliance?: number|string, asset?: number|string }} opts
 */
export function riskCenterPath(tab = DEFAULT_RISK_CENTER_TAB, { department, compliance, asset } = {}) {
  const safeTab = isValidRiskCenterTab(tab) ? tab : DEFAULT_RISK_CENTER_TAB;

  if (compliance != null && compliance !== "") {
    const params = new URLSearchParams();
    if (asset != null && asset !== "") {
      params.set("asset", String(asset));
    }
    const qs = params.toString();
    return `/risk_center/compliance/${compliance}/${safeTab}${qs ? `?${qs}` : ""}`;
  }

  const params = new URLSearchParams();
  if (department != null && department !== "") {
    params.set("department", String(department));
  }
  if (asset != null && asset !== "") {
    params.set("asset", String(asset));
  }
  const qs = params.toString();
  return `/risk_center/${safeTab}${qs ? `?${qs}` : ""}`;
}

/** Read optional ?asset= from search string. */
export function parseAssetIdFromSearch(search) {
  const params = new URLSearchParams(search || "");
  const raw = params.get("asset");
  if (!raw) return null;
  const id = parseInt(raw, 10);
  return Number.isFinite(id) ? id : null;
}

/** Parse pathname + search into Risk Center navigation state. */
export function parseRiskCenterLocation({ pathname, search }) {
  const parts = pathname.split("/").filter(Boolean);

  if (parts[1] === "compliance") {
    const complianceId = parts[2] ? parseInt(parts[2], 10) : null;
    const tab = parts[3] || DEFAULT_RISK_CENTER_TAB;
    return {
      mode: "compliance",
      complianceId: Number.isFinite(complianceId) ? complianceId : null,
      tab: isValidRiskCenterTab(tab) ? tab : DEFAULT_RISK_CENTER_TAB,
      department: null,
    };
  }

  const tab = parts[1] || DEFAULT_RISK_CENTER_TAB;
  const params = new URLSearchParams(search || "");
  const deptRaw = params.get("department");
  const department = deptRaw ? parseInt(deptRaw, 10) : null;

  return {
    mode: "department",
    tab: isValidRiskCenterTab(tab) ? tab : DEFAULT_RISK_CENTER_TAB,
    department: Number.isFinite(department) ? department : null,
    complianceId: null,
  };
}
